"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLatestSmartReading = exports.getLatestActualReading = void 0;
var utils_1 = require("./utils");
var getLatestActualReading = function (readings) {
    var readsToValidateAgainst = readings.filter(function (reading) { return (0, utils_1.getReadingTypeLabel)(reading.readingType) !== 'Estimated'; });
    return readsToValidateAgainst.sort(utils_1.mostRecentFirst)[0];
};
exports.getLatestActualReading = getLatestActualReading;
var getLatestSmartReading = function (readings) {
    var readsToValidateAgainst = readings.filter(function (reading) { return (0, utils_1.getReadingTypeLabel)(reading.readingType) === 'Smart'; });
    return readsToValidateAgainst.sort(utils_1.mostRecentFirst)[0];
};
exports.getLatestSmartReading = getLatestSmartReading;
